import { render, staticRenderFns } from "./CategoryGroup.vue?vue&type=template&id=c2b6fb80"
import script from "./CategoryGroup.vue?vue&type=script&lang=js"
export * from "./CategoryGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2b6fb80')) {
      api.createRecord('c2b6fb80', component.options)
    } else {
      api.reload('c2b6fb80', component.options)
    }
    module.hot.accept("./CategoryGroup.vue?vue&type=template&id=c2b6fb80", function () {
      api.rerender('c2b6fb80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/CategoryGroup.vue"
export default component.exports